const tuPageHeadings = {
  827487: {
    'type:casual-shirts': 'Mens Casual Shirts'
  },
  828032: {
    'type:leggings': 'Womens Maternity Leggings',
    'type:jeans': 'Womens Maternity Jeans',
    'type:maternity-bras': 'Womens Maternity Bras',
    'type:maternity-dresses': 'Womens Maternity Dresses',
    'type:maternity-knickers': 'Womens Maternity Knickers',
    'type:swimsuits': 'Womens Maternity Swimsuits',
    'type:t%252Dshirts': 'Womens Maternity T-Shirts',
    'type:tights': 'Womens Maternity Tight',
    'type:tops': 'Womens Maternity Tops'
  },
  828033: {
    'type:dresses': 'Womens Dresses Petite',
    'type:jeans': 'Womens Petite Jeans'
  },
  840365: {
    'type:bibs': 'Baby Multipack Bibs'
  },
  840375: {
    'type:bralettes-and-crop-tops': 'Bralettes and Crop Tops',
    'type:dd-%252D-gg-bras': 'DD - GG Bras',
    'type:invisible-bras': 'Invisible Bras',
    'type:lounge-bras': 'Lounge Bras',
    'type:maternity-bras': 'Maternity Bras',
    'type:multipack-bras': 'Multipack Bras',
    'type:non%252Dwired-bras': 'Non-Wired Bras',
    'type:strapless-and-multiway-bras': 'Strapless and Multiway Bras',
    'type:t%252Dshirt-bras': 'T-Shirt Bras',
    'type:underwired-bras': 'Underwired Bras'
  },
  840376: {
    'type:thongs': 'Thong Knickers',
    'type:cotton-knickers': 'Cotton Knickers',
    'type:lace-knickers': 'Lace Knickers',
    'type:multipack-knickers': 'Multipack Knickers',
    'type:shapewear-knickers': 'Shapewear Knickers'
  },
  840377: {
    'type:shapewear-knickers': 'Shapewear Knickers'
  },
  840385: {
    'type:pyjama-sets': 'Boys Multipack Pyjama Sets'
  },
  840387: {
    'type:all-in-ones': 'Boys All-in-One Pyjamas'
  },
  840393: {
    'type:shorts': 'Boys Sports Shorts',
    'type:joggers': 'Boys Sports Joggers'
  },
  840397: {
    'type:tights': 'Girls Ballet Tights'
  },
  840400: {
    'type:crop-tops': 'Girls Crop Top Multipacks',
    'type:leggings': 'Girls Leggings Multipacks',
    'type:pyjama-sets': 'Girls Multipack Pyjama Sets',
    'type:t%252Dshirts': 'Girls Multipack T- Shirts'
  },
  840401: {
    'type:all-in-ones': 'Girls All-in-One Nightwear'
  },
  840410: {
    'type:shorts': 'Girls Sports Shorts'
  },
  841793: {
    'type:t%252Dshirts': 'Mens Sportswear T-Shirts',
    'type:hoodies': 'Mens Sports Hoodies',
    'type:joggers': 'Mens Sports Joggers'
  },
  841795: {
    'type:swim-shorts': 'Mens Swim Shorts'
  },
  841796: {
    'type:cargo-trousers': 'Mens Cargo Trousers',
    'type:casual-trousers': 'Mens Casual Trousers'
  },
  841885: {
    'type:quilted-coats': 'Womens Quilted Coats'
  },
  841887: {
    'type:puffer-jackets': 'Womens Puffer Jackets'
  },
  841889: {
    'type:jumper-dresses': 'Womens Jumper Dresses',
    'type:cami-dresses': 'Womens Cami Dresses',
    'type:pinafore-dresses': 'Womens Pinafore Dresses',
    'type:shift-dresses': 'Womens Shift Dresses',
    'type:shirt-dresses': 'Womens Shirt Dresses',
    'type:summer-dresses': 'Womens Summer Dresses',
    'type:tea-dresses': 'Womens Tea Dresses'
  },
  841907: {
    'type:hooded-blankets': 'Womens Hooded Blankets'
  },
  841942: {
    'type:crop-tops': 'Womens Crop Tops',
    'type:tank-tops': 'Womens Tank Tops'
  },
  841944: {
    'type:bags': 'Womens Work Bags',
    'type:shoes': 'Womens Work Shoes',
    'type:trousers': 'Womens Work Trousers'
  },
  842023: {
    'type:fancy-dress-costumes': 'Kids Character Shop Fancy Dress Costumes'
  },
  842025: {
    'type:trainers': 'Boys School Trainers'
  },
  842028: {
    'type:hoodies': 'Boys PE Hoodies',
    'type:joggers': 'Boys PE Joggers',
    'type:shorts': 'Boys PE Shorts',
    'type:trainers': 'Boys PE Trainers'
  },
  842030: {
    'type:jumpers': 'Boys School Jumpers'
  },
  842035: {
    'type:plimsolls': 'Girls Plimsolls'
  },
  842038: {
    'type:hoodies': 'Girls PE Hoodies',
    'type:joggers': 'Girls PE Joggers',
    'type:shorts': 'Girls PE Shorts',
    'type:t%252Dshirts': 'Girls PE T-Shirts',
    'type:trainers': 'Girls PE Trainers'
  },
  842041: {
    'type:school-pinafores': 'Girls School Pinafores'
  },
  842046: {
    'type:trousers': 'Girls School Trousers'
  },
  1033929: {
    'type:all-in-ones': 'Kids All-in-One Nightwear'
  },
  1033948: {
    'type:joggers': 'Kids Joggers Multipacks',
    'type:leggings': 'Kids Leggings Multipacks',
    'type:school-socks': 'Kids School Socks Multipacks',
    'type:shorts': 'Kids Shorts Multipacks'
  },
  1034390: {
    'type:tops': 'Womens Plus Size Tops'
  },
  1041285: {
    'type:sliders': 'Kids Sliders'
  },
  1041341: {
    'type:pyjama-sets': 'Kids Character Shop Pyjama Sets',
    'type:t%252Dshirts': 'Kids Character Shop T-Shirts'
  },
  1044086: {
    'type:underwired-bras': 'Underwired DD-J Bras'
  }
}

export default tuPageHeadings
